module.exports = __webpack_public_path__ + "img/jieti.ded47cdb.png";